import React from 'react';

const ServiceRequestContext = React.createContext({});

export default ServiceRequestContext;
